// extracted by mini-css-extract-plugin
export default {"contentWithoutBets":"_35qQY","contentWithMainBets":"_3wxwR","expansionText":"_2zxL3","expansion":"_30ASg","rightCellHeadToHead":"e3OL-"};